'use client';

import {SWRConfig, type SWRConfiguration} from 'swr';

// import {HTTPError} from '@/lib/fetch/base';

const options: SWRConfiguration = {
  dedupingInterval: 2e3,
  errorRetryInterval: 5e3,
  shouldRetryOnError: false,
  revalidateIfStale: false,
  revalidateOnFocus: false,
  /** @todo Send toast notification for rate limit errors and offline server. */
  // onError: (error, key) => {
  //   if (error instanceof HTTPError) {
  //     if (error.code === 429) {
  //     }
  //   }
  // }
};

export default function SWRProvider({children}: {children: React.ReactNode}) {
  return <SWRConfig value={options}>{children}</SWRConfig>;
}
